import {Typography} from '@material-ui/core';
import {AsyncError, ServerError, Unauthorized} from 'Core/models/Async';
import * as React from 'react';
import './ErrorPage.sass';

type CustomMessage = {
  message: React.ReactNode;
};

type TErrorPageProps = {
  error: ServerError | Unauthorized | CustomMessage;
};

export const CustomErrorPage = (props: {message: React.ReactNode}) => (
  <div className="error-page__container">
    <div>
      <Typography>{props.message}</Typography>
    </div>
  </div>
);

const ErrorPage = (props: TErrorPageProps) => (
  <div className="error-page__container">
    <div>
      <Typography>{props.error.message}</Typography>
    </div>
  </div>
);

export const ShowErrorPage = (error: AsyncError) => <ErrorPage error={error} />;

export default ErrorPage;
